import { BookmarkData } from "@/models/powerbi";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IVisual {
  pageId: string;
  fieldName: string;
  tableName: string;
  slicerId: string;
  slicerName: string;
  slicerType: string;
  type: string;
  availableValues: string[];
}
export interface IPowerBiSlice {
  currentPage: {
    pageId: string;
    name: string;
    displayName: string;
  } | null;
  visuals: IVisual[] | null;
  savedVisuals?: Record<string, BookmarkData> | null;
  bookmarkState?: string | null;
  reload: boolean;
  previousPage:{
    pageId: string;
    name: string;
    displayName: string;
  } | null;
  isLoaded: boolean;
  currentSampleSize: string | null;
  isRemove: boolean;
  isLoadingfilterPI: boolean;
}

const initialState: IPowerBiSlice = {
  currentPage: null,
  visuals: null,
  savedVisuals: null,
  bookmarkState: null,
  reload: false,
  previousPage: null,
  isLoaded: true,
  currentSampleSize: null,
  isRemove: false,
  isLoadingfilterPI: false
};

export const powerBiSlice = createSlice({
  name: "report",
  initialState,
  reducers: {
    setCurrentPagePowerBi: (
      state,
      action: PayloadAction<{
        pageId: string;
        name: string;
        displayName: string;
      }>
    ) => {
      state.currentPage = action.payload;
    },
    setVisual: (state, action: PayloadAction<IVisual[]>) => {
      state.visuals = action.payload;
    },
    setSavedVisuals: (
      state,
      action: PayloadAction<Record<string, BookmarkData> | null>
    ) => {
      state.savedVisuals = action.payload;
    },
    setBookmarkState: (state, action: PayloadAction<string | null>) => {
      state.bookmarkState = action.payload;
    },
    setReload: (state, action: PayloadAction<boolean>) => {
      state.reload = action.payload;
    },
    setPreviousPage: (state, action: PayloadAction<{
      pageId: string;
      name: string;
      displayName: string;
    } | null>) => {
      state.previousPage = action.payload;
    },
    setIsLoaded: (state, action: PayloadAction<boolean>) => {
      state.isLoaded = action.payload;
    },
    setCurrentSampleSize: (state, action: PayloadAction<string | null>) => {
      state.currentSampleSize = action.payload;
    },
    setIsRemove: (state, action: PayloadAction<boolean>) => {
      state.isRemove = action.payload;
    },
    setIsLoadingFilterPI: (state, action: PayloadAction<boolean>) => {
      state.isLoadingfilterPI = action.payload;
    },
  },
});

export const {
  setCurrentPagePowerBi,
  setVisual,
  setSavedVisuals,
  setBookmarkState,
  setReload,
  setPreviousPage,
  setIsLoaded,
  setCurrentSampleSize,
  setIsRemove,
  setIsLoadingFilterPI
} = powerBiSlice.actions;
export default powerBiSlice.reducer;
